import styled from "styled-components";

export default styled.select`
  width: 100%;
  border: none;
  border: ${(props) =>
    props.showError ? "1px solid #FF5D4C" : "1px solid #AEAEAE"};
  color: ${(props) => (props.noValue ? "#738A94" : "#3F3F40")};
  font-size: 14px;
  font-family: "Poppins", "sans-serif";
  cursor: pointer;

  -webkit-appearance: none;
  -webkit-border-radius: 0px;
  -moz-appearance: none;
  text-overflow: "";
  padding: 12px 18px;
  border-radius: 5px;

  & > * {
    font-family: "Poppins", "sans-serif";
  }

  &:hover {
    // border-bottom: 1px solid #3f3f40;
  }
`;
